'use client'

import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { useRoutingLocale } from '@/utils/l10n/useRoutingLocale'
import { PageLink } from '@/utils/PageLink'
import { HedvigLogo } from 'ui/src/components/HedvigLogo/HedvigLogo'
import { link } from './LogoHomeLink.css'

export const LogoHomeLink = () => {
  const { t } = useTranslation('common')
  const locale = useRoutingLocale()

  // Optimization: we don't want prefetch on navigation element, it's always visible
  // and not used often enough to justify eager preload.
  // Not prefetching also makes it easier to measure page-specific performance
  // (no extra resources from preloaded pages)
  return (
    <Link
      className={link}
      href={PageLink.home({ locale }).pathname}
      aria-label={t('HOME_PAGE_LINK_LABEL')}
      prefetch={false}
    >
      {/* Image here is just for decorative purposes, so we hide it from screen readers */}
      {/* Descriptive meaning is provided by link's aria-label */}
      <HedvigLogo aria-hidden={true} />
    </Link>
  )
}
